module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-nw.d69c312b.png";